import { render, staticRenderFns } from "./CtaAlertModule.vue?vue&type=template&id=22c11e6c&"
import script from "./CtaAlertModule.ts?vue&type=script&lang=ts&"
export * from "./CtaAlertModule.ts?vue&type=script&lang=ts&"
import style0 from "./CtaAlertModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports